import { mui, theme, styled, React } from "aaa";

// Expose needed material-ui svg icons...
type MuiSVGIconConstructor = new () => mui.SvgIcon;

export const IconDone: MuiSVGIconConstructor = require("material-ui/svg-icons/action/done").default;
export const IconRestore: MuiSVGIconConstructor = require("material-ui/svg-icons/action/restore").default;
export const IconTrash: MuiSVGIconConstructor = require("material-ui/svg-icons/action/delete").default;
export const IconCheckCircle: MuiSVGIconConstructor = require("material-ui/svg-icons/action/check-circle").default;


export const Text = styled.p`
    margin: 0;
    padding: 0;
`;

export const InfoText = styled.p`
    margin: 0;
    padding: 0;
    color: #b2b2b2;
    font-size: 13px;
    font-weight: lighter;
`;

export const TextH3 = styled.h3`
    margin: 0;
    padding: 0;
`;

export const TextH4 = styled.h4`
    margin: 0;
    padding: 0;
`;

export const SliderLabelLeft = styled.div`
    width: 65px;
    font-size: 12px;
    margin-top: 32px;
    margin-right: -20px;
`;

export const SliderLabelRight = styled.div`
    font-size: 12px; 
    margin-top: 32px; 
    margin-left: -20px;
`;

export const LightText = styled.p`
    margin: 0;
    padding: 0;
    font-weight: lighter;
`;

export const LightTextSpan = styled.span`
    font-weight: lighter;
`;

export const HFlex = styled.div`
    display: flex;
`;

export const HFlexCentered = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const VFlex = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HCenterDiv = styled.div`
    width: 100%;
    text-align: center;
`;

export const FormContainer = styled.div`
    padding: ${theme.MARGIN_BIG}px;
`;

export const Title = styled.h2`
    margin-top: 0px;
    margin-bottom: 0px;
    color: ${theme.SPARDA_BLUE};
`;


export const Subtitle = styled.h3`
    margin-top: 20px;
    margin-bottom: 0px;
    color: ${theme.SPARDA_BLUE};
`;

export const Separator = () => <div style={{ height: theme.MARGIN, background: "#f1f5fa" }} />;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Primitives.tsx